"use strict";

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var core_1 = require("@comunica/core");
/**
 * A logger that voids everything.
 */


var LoggerVoid =
/*#__PURE__*/
function (_core_1$Logger) {
  _inherits(LoggerVoid, _core_1$Logger);

  function LoggerVoid() {
    _classCallCheck(this, LoggerVoid);

    return _possibleConstructorReturn(this, _getPrototypeOf(LoggerVoid).apply(this, arguments));
  }

  _createClass(LoggerVoid, [{
    key: "debug",
    value: function debug(message, data) {// Void
    }
  }, {
    key: "error",
    value: function error(message, data) {// Void
    }
  }, {
    key: "fatal",
    value: function fatal(message, data) {// Void
    }
  }, {
    key: "info",
    value: function info(message, data) {// Void
    }
  }, {
    key: "trace",
    value: function trace(message, data) {// Void
    }
  }, {
    key: "warn",
    value: function warn(message, data) {// Void
    }
  }]);

  return LoggerVoid;
}(core_1.Logger);

exports.LoggerVoid = LoggerVoid;